import React, { Component } from 'react'
import CircularProgress from "../../../useful/CircularProgress";


class MessageStatusView extends Component {
    render() {
        let status = this.props.status
        let iconColor = this.props.iconColor ?? 'blue'
        return (
            <div style={{}}>
                {(status == 0 || status == null) && (
                    <img className='flexcc' src={`/assets/icons/messenger/pending-${iconColor}.svg`} width={14} height={14} style={{ objectFit: 'contain' }} alt='' />
                )}

                {(status == 1) && (
                    <img className='flexcc ' src={`/assets/icons/messenger/sent-${iconColor}.svg`} width={14} height={14} style={{ objectFit: 'contain',padding:this.props.sentPadding }} alt='' />
                )}

                {(status == 2) && (
                    <img className='flexcc' src={`/assets/icons/messenger/seen-${iconColor}.svg`} width={14} height={14} style={{ objectFit: 'contain' }} alt='' />
                )}
            </div>

        )
    }
}

export default MessageStatusView;